import { render } from "./CreditNote.vue?vue&type=template&id=276d3e5a&scoped=true"
import script from "./CreditNote.vue?vue&type=script&lang=js"
export * from "./CreditNote.vue?vue&type=script&lang=js"

import "./CreditNote.vue?vue&type=style&index=0&id=276d3e5a&scoped=true&lang=css"

import exportComponent from "/usr/local/var/www/duo_front/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-276d3e5a"]])

export default __exports__